module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/testimonials/diego-batara-mahameru-307d605a0e6e4979f0662897a4695526.jpg";